import React, { useEffect, useState } from "react";
import Link from "../../components/common/Link";
import { Collapse, Form, Tab, Tabs } from "react-bootstrap";
import HttpService from "../../helpers/httpServices";
import { useDispatch, useSelector } from "react-redux";
import { Postdata } from "../../helpers/api.service";
import Page from "../../helpers/config";
import { message } from "../../redux/actions/toastActions";
import DataTableBase from "../../components/common/DataTableBase";
import ModalPopup from "../../components/common/Modal";
import Title from "../../components/common/Title";
import Breadcrumb from "../../components/common/Breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import { Topbar } from "../../components/include/Topbar";
import filterIcon from "../../assets/Icons/filter.svg";
import ResetIcon from "../../assets/Icons/reset.svg";
import Pagination from "../../components/common/Pagination";
import { isPermission, isRole } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calender from "../../assets/Icons/calendar.png"
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";

const School_List = () => {
  const [data, setData] = useState([]);
  const [isloading, setIsloading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setperPage] = useState(Page.records);
  const [currentPage, setcurrentPage] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const [search, setSearch] = useState(false);
  const [modaldelete, setmodalDelete] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [modalswitch, setmodalswitch] = useState(false);
  const [modalswitchcontent, setmodalswitchcontent] = useState([0, 0]);
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState(null);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole)

  const isAccessible = role === "admin" || role === "subadmin" || role === "schooladmin" || permissions && (permissions?.includes('view_School_Management') || permissions?.includes('view_School')) || false;
  const addPermission = role === "admin" || role === "subadmin" || role === "schooladmin" || permissions && (permissions?.includes('edit_School_Management') || permissions?.includes('edit_School')) || false;
  const location = useLocation();

  const handleStatusChange = (id, status) => {
    setmodalswitchcontent([id, status]);
    setmodalswitch(true);
  };

  const handleDelete = () => {
    if (deleteId && deleteId !== "") {
      setmodalDelete(false);
      setIsloading(true);
      Postdata(HttpService.board_management_remove, {
        id: deleteId,
      }).then((res) => {
        setRefresh(!refresh);
        dispatch(message(res.message));
      });
    }
  };

  const handleStatusChangeAction = () => {
    setmodalswitch(false);
    setIsloading(true);
    Postdata(HttpService.board_management_add, {
      id: modalswitchcontent[0],
      status: Number(modalswitchcontent[1]),
    }).then((res) => {
      setRefresh(!refresh);
      dispatch(message(res.message));
    });
  };

  const handleRowsPerPageChange = (rows) => {
    setperPage(rows);
    setcurrentPage(1);
    SchoolListData(1, rows);
  };

  const handlePageChange = (page) => {
    setcurrentPage(page);
    SchoolListData(page, perPage);
  };
  const schoolId =
    location.state?.schoolId ||
    localStorage.getItem("activeSchoolId");

  const SchoolListData = (currentPage, perPage) => {
    setIsloading(true);
    // Helper function to format date in local timezone
    const formatLocalDate = (date) => {
      if (!date) return "";
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    Postdata(HttpService.school_management_list, {
      page: currentPage,
      perpage: perPage,
      search: search ? search : "",
      ...(startDate && { startDate: formatLocalDate(startDate) }),
      ...(endDate && { endDate: formatLocalDate(endDate) }),
      ...(status !== null && { status: status === "active" ? 1 : 0 }),
      ...(schoolId && { school_id: schoolId }),
    })
      .then((response) => {
        if (response.status === 200) {
          setData(response.data.managers);
          setTotalRows(response.data.count);
          setIsloading(false);
        } else {
          setIsloading(false);
          dispatch(message(response.message));
        }
      })
      .catch((e) => {
        setIsloading(false);
        dispatch(message(e.message));
      });
  }
  useEffect(() => {
    SchoolListData(currentPage, perPage);
  }, [refresh]);

  useEffect(() => {
    if (search !== false) {
      const timeOutId = setTimeout(() => setRefresh(!refresh), 500);
      return () => clearTimeout(timeOutId);
    }
  }, [search]);

  if (!isAccessible) {
    return (
      <>
        <Error403Page />
      </>
    );
  }

  return (
    <>
      <Title name="School Management" />
      <ModalPopup
        className="alert-box-popup"
        show={modalswitch}
        size="md"
        onHide={() => setmodalswitch(false)}
        heading="Are you sure?"
      >


        <div className="text-start flex justify-center flex-col items-center gap-3 px-3 relative ">
          <img
            src={ResetIcon}
            alt=""
            className="absolute top-2 right-2 cursor-pointer"
            onClick={() => {
              setStartDate("");
              setEndDate("");
              setStatus(null); // reset status
            }}
          />
          <h3>Filters</h3>

          {/* Start Date */}
          <div className="w-full">
            <label className="block mb-1 font-medium text-gray-700">
              Start Date
              {/* <span className="text-red-500">*</span> */}
            </label>
            <div className="relative">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="dd/MM/yyyy"
                className="w-96  p-3 bg-gray-100 rounded-xl pr-10"
                id="startDate"
                name="startDate"
                placeholderText="dd/mm/yyyy"
                minDate={new Date("1900-01-01")}
                maxDate={new Date("9999-12-31")}
                onChangeRaw={(e) => e.preventDefault()}
                autoComplete="off"
              />
              {/* Responsive Calendar Icon */}
              <img
                src={calender}
                alt="Calendar Icon"
                className="absolute right-16 top-1/2 -translate-y-1/2 h-[0.8em] w-[0.8em] md:h-[1em] md:w-[1em] xl:h-[1.2em] xl:w-[1.2em] pointer-events-none"
              />
            </div>
          </div>

          {/* End Date */}
          <div className="w-full">
            <label className="block mb-1 font-medium text-gray-700">
              End Date
              {/* <span className="text-red-500">*</span> */}
            </label>
            <div className="relative">
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="dd/MM/yyyy"
                className="w-96  p-3 bg-gray-100 rounded-xl pr-10"
                id="endDate"
                name="endDate"
                placeholderText="dd/mm/yyyy"
                minDate={startDate || new Date("1900-01-01")} // ✅ prevents earlier than start date
                maxDate={new Date("9999-12-31")}
                onChangeRaw={(e) => e.preventDefault()}
                autoComplete="off"
                popperClassName="enddate-popper"
              />
              {/* Responsive Calendar Icon */}
              <img
                src={calender}
                alt="Calendar Icon"
                className="absolute right-16 top-1/2 -translate-y-1/2 h-[0.8em] w-[0.8em] md:h-[1em] md:w-[1em] xl:h-[1.2em] xl:w-[1.2em] pointer-events-none"
              />
            </div>
          </div>

          <div className="w-full">
            <label className="block mb-1 font-medium text-gray-700">
              Status
            </label>
            <div className="flex gap-2 text-center w-48">
              {["active", "inactive"].map((item) => (
                <div
                  key={item}
                  className={`cursor-pointer input-field-grey ${status === item
                    ? "border-secondary_main border-1 text-secondary_main bg-white"
                    : "input-field-grey"
                    }`}
                  onClick={() => setStatus(item)}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </div>
              ))}
            </div>
          </div>
          <div className="w-full flex justify-between gap-3 mb-2 mt-2">
            <button
              className="button-field-primary"
              style={{ width: "100%" }}
              onClick={() => {
                setmodalswitch(false);
                setRefresh((prev) => !prev); // trigger useEffect
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </ModalPopup>

      <ModalPopup
        className="alert-box-popup"
        show={modaldelete}
        size="sm"
        onHide={() => setmodalDelete(false)}
        heading="Are you sure?"
      >
        <i className="mdi mdi-check"></i>
        <p>You want to delete the School!</p>
        <div className="actions">
          <button className="btn btn-primary" onClick={() => handleDelete()}>
            Yes, Delete It
          </button>
          <button
            className="btn btn-danger"
            onClick={() => setmodalDelete(false)}
          >
            Cancel
          </button>
        </div>
      </ModalPopup>

      <Topbar title="School Management" />
      <div className="p-6 space-y-6 pr-0">
        {
          // isAccessibleToAddSchoolMember &&
          <div className="flex justify-end">
            <div className="flex gap-2">
              {addPermission && role !== "admin" && <button
                className="bg-primary_main text-white px-4 py-2 rounded-lg whitespace-nowrap"
                onClick={() => navigate("school-management/add-member")}
              >
                Add Members
              </button>}
              <div
                className="bg-white text-black px-[15px]  rounded-lg whitespace-nowrap flex items-center cursor-pointer"
                onClick={() => setmodalswitch(true)}
              >
                <img src={filterIcon} alt="" className="" />
              </div>
            </div>
          </div>
        }

        <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
          {isloading ? (
            <div className="w-full col-span-3 flex justify-center items-center">
              Loading...
            </div>
          ) : (
            data?.map((member, index) => (
              <Link
                key={index}
                to={`/school-management/view/${member._id}`}
                className="bg-white rounded-lg p-[15px] hover:shadow-xl transition-shadow duration-300"
              >
                <div className="flex items-start gap-2">
                  <img
                    src={member.profile_img}
                    className="w-12 h-12 rounded-full bg-gray-300 object-cover"
                  />
                  <div className="flex-1">
                    <h3 className="font-semibold text-card-title mb-1 text-gray-800">
                      {member.name.length > 15 ? `${member.name.slice(0, 15)}...` : member.name}
                    </h3>
                    <p className="text-card-role text-gray-600">
                      {member.designation.length > 15 ? `${member.designation.slice(0, 15)}...` : member.designation}
                    </p>
                  </div>

                </div>
                <p className="mt-3 pb-0 text-card-body text-gray-700 line-clamp-3 break-words">
                  {member.bio}
                </p>
              </Link>
            ))
          )}
        </div>

        <Pagination
          currentPage={currentPage}
          totalRows={totalRows}
          perPage={perPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
        {
          !isloading && data.length === 0 && <div className="h-[50vh] flex items-center justify-center w-full">
            <h1 className="text-center text-gray-400">No Data Found</h1>
          </div>
        }
      </div>
    </>
  );
};

export default School_List;

//  <>
//     <Title name='Board Management' />

//     <ModalPopup
//       className="alert-box-popup"
//       show={modalswitch}
//       size="sm"
//       onHide={() => setmodalswitch(false)}
//       heading="Are you sure?"
//     >
//       <i className="mdi mdi-check"></i>
//       <p>You want to change this status!</p>
//       <div className='actions'>
//         <button className="btn btn-primary" onClick={() => handleStatusChangeAction()}>Yes, Change Status</button>
//         <button className="btn btn-danger" onClick={() => setmodalswitch(false)}>Cancel</button>
//       </div>
//     </ModalPopup>

//     <ModalPopup
//       className="alert-box-popup"
//       show={modaldelete}
//       size="sm"
//       onHide={() => setmodalDelete(false)}
//       heading="Are you sure?"
//     >
//       <i className="mdi mdi-check"></i>
//       <p>You want to delete the School!</p>
//       <div className='actions'>
//         <button className="btn btn-primary" onClick={() => handleDelete()}>Yes, Delete It</button>
//         <button className="btn btn-danger" onClick={() => setmodalDelete(false)}>Cancel</button>
//       </div>
//     </ModalPopup>

//     <div className="row">
//       <div className="col-lg-4">
//         <h4>Board Management</h4>
//         <Breadcrumb
//           active="Board Management"
//         />
//       </div>
//       <div className="col-lg-8 text-end">

//         <Link to={'/board-management/add'} className="btn btn-custom">Add New School</Link>

//         <button className="btn btn-danger" onClick={() => setOpen(!open)}>Search</button>
//       </div>
//     </div>

//     <Collapse in={open}>
//       <div>
//         <div className="card">
//           <p className="card-header">Search</p>
//           <div className="card-body">
//             <div className="row">
//               <div className='col-lg-3'>
//                 <Form.Group className="form-group mb-0">
//                   <Form.Label>Search By</Form.Label>
//                   <Form.Select
//                     className='customOption'
//                     onChange={e => setSearch(e.target.value)} >
//                     <option value="name">Name</option>
//                   </Form.Select>
//                 </Form.Group>
//               </div>
//               <div className="col-lg-3">
//                 <Form.Group className="form-group mb-0">
//                   <Form.Label>Search</Form.Label>
//                   <Form.Control
//                     type="text"
//                     onChange={e => setSearch(e.target.value)}
//                     required
//                   />
//                 </Form.Group>
//               </div>

//                   <div className="col-md-3">
//                       <Form.Group>
//                           <Form.Label>Start Date</Form.Label>
//                           <Form.Control
//                               type="date"
//                               value={startDate}
//                               onChange={(e) => { setStartDate(e.target.value); setRefresh(!refresh) }}
//                           />
//                       </Form.Group>
//                   </div>
//                   <div className="col-md-3">
//                       <Form.Group>
//                           <Form.Label>End Date</Form.Label>
//                           <Form.Control
//                               type="date"
//                               value={endDate}
//                               onChange={(e) => { setEndDate(e.target.value); setRefresh(!refresh) }}
//                           />
//                       </Form.Group>
//                   </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </Collapse>

//     <div className="card">
//       <p className="card-header">List of Board Managers</p>
//       <div className="card-body">
//         <DataTableBase
//           columns={columns}
//           loader={isloading}
//           data={data}
//           paginationTotalRows={totalRows}
//           onChangeRowsPerPage={handlePerRowsChange}
//           onChangePage={handlePageChange}
//         />
//       </div>
//     </div>
//   </>
